<div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">UPSI Sharer</h5>
      <button aria-label="Close" class="close" type="button" (click)="activeModal.dismiss('dismiss')">
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <span style="color: red; text-align: center;" *ngIf="errorMessage">Please select sharer user from list.</span>
        <div class="col-sm-12">
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="sharerGovevaUserList"
            class="table table-hover compact cell-border nowrap stripe" [hidden]="typeOfUserList != 'govevaUser'">
            <thead>
              <tr>
                <th>Select</th>
                <th>Name</th>
                <th>Designation</th>
                <th>Email Id</th>
                <th>Sharer Code</th>
                <th>Unique Identifier Type</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of internalUser; let count = index">
                <td>
                  <!-- <input type="radio" name="internalUser" class="md-checkbox" (click)="selectUser($event, user._id)"> -->
                  <div class="md-checkbox">
                    <input type="checkbox" name="internalUser" id="selectedUser{{count + 1}}"
                      [(ngModel)]="user.IsSelected" (click)="selectUser($event, user._id, count)">
                    <label for="selectedUser{{count + 1}}">&nbsp;</label>
                  </div>
                </td>
                <td>
                  {{ user.Title + ' ' + user.FirstName + ' ' + user.LastName }}
                </td>
                <td>
                  {{user.Designation}}
                </td>
                <td>
                  {{user.EmailId}}
                </td>
                <td>
                  -
                </td>
                <td>
                  PAN
                </td>
              </tr>
            </tbody>
          </table>
          <table datatable [dtOptions]="dtOptionsForUPSISharer" [dtTrigger]="dtTriggerForUPSISharer" id="sharerNonGovevaUserList" class="table table-hover compact cell-border nowrap stripe"
            [hidden]="typeOfUserList != 'nonGovevaUser'">
            <thead>
                <tr>
                  <th>Select</th>
                  <th>Name</th>
                  <th>Designation</th>
                  <th>Email Id</th>
                  <th>Sharer Code</th>
                  <th>Unique Identifier Type</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let UPSIUser of UPSIUserList; let count = index">
                  <td>
                    <!-- <input type="radio" name="internalUser" class="md-checkbox" (click)="selectUser($event, user._id)"> -->
                    <div class="md-checkbox">
                      <input type="checkbox" name="internalUser" id="selectedUPSIUser{{count + 1}}"
                        [(ngModel)]="UPSIUser.IsSelected" (click)="selectUser($event, UPSIUser._id, count)">
                      <label for="selectedUPSIUser{{count + 1}}">&nbsp;</label>
                    </div>
                  </td>
                  <td>
                    {{ UPSIUser.Name }}
                  </td>
                  <td>
                    {{UPSIUser.Designation}}
                  </td>
                  <td>
                    {{UPSIUser.email_id}}
                  </td>
                  <td>
                    {{UPSIUser.EmpCode}}
                  </td>
                  <td>
                    {{UPSIUser.Unique_Identifier_Type}}
                  </td>
                </tr>
              </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-sm btn-danger" (click)="save()">
        <i class="fa fa-check"></i>&nbsp;Save</button>
      <button type="button" class="btn btn-sm btn-primary" (click)="activeModal.dismiss('dismiss')">
        <i class="fa fa-times"></i>&nbsp;Cancel</button>
    </div>
  </div>